__turbopack_context__.v({
  "categories": "categoryLinks-module-scss-module__DL46gG__categories",
  "category": "categoryLinks-module-scss-module__DL46gG__category",
  "categoryName": "categoryLinks-module-scss-module__DL46gG__categoryName",
  "mobileHeader": "categoryLinks-module-scss-module__DL46gG__mobileHeader",
});
